<template>
    <tailwind-layout title="Billing">
        <div>
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="bg-white pt-8 pb-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-8">
                        <!-- 86bc63aqb: the amount was only stated inside the warning above the
                             Purchase button. 86bce6r42: the summary is shared with the unlock
                             popup; the Applicant Boost is no longer sold. -->
                        <self-check-cart-summary
                            v-if="billing_type === 'report'"
                            class="mb-6"
                            :report-id="report_id"
                            :summary-lines="summary_lines"
                            :amount="amount"
                            :discount="discount"
                            :seconds-left="secondsLeft"
                            :countdown="countdown"
                        />
                        <stripe-form
                            :publishable_key="publishable_key"
                            :payment_intent="payment_intent"
                            :user="user"
                            :amount="amount"
                            :first_name="first_name"
                            :last_name="last_name"
                            :billing_type="billing_type"
                            :report_id="report_id"
                            :application_id="application_id"
                            :show-title="true"
                            :show-report-warning="true"
                        />
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import StripeForm from '@/Components/StripeForm.vue'
import SelfCheckCartSummary from '@/Components/SelfCheckCartSummary.vue'
import { useCountdown } from '@/Pages/Reports/countdown.js'
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";

export default {
    props: {
        publishable_key: String,
        amount: String,
        first_name: String,
        last_name: String,
        billing_type: String,
        report_id: [String, Number],
        application_id: String,
        user: Object,
        payment_intent: Object,
        summary_lines: {
            type: Array,
            default: () => [],
        },
        discount: {
            type: Object,
            default: () => ({ offered: false, open: false, applied: false, code: '', percent: 0, amount: '0.00', seconds_left: 0 }),
        },
    },
    setup(props) {
        const user = computed(() => usePage().props.auth.user);
        const { secondsLeft, countdown } = useCountdown(() => props.discount.seconds_left);
        return {user, secondsLeft, countdown};
    },
    components: {
        TailwindLayout,
        StripeForm,
        SelfCheckCartSummary,
    },
}
</script>
